export default __webpack_public_path__ + "static/media/WAG Symbols.54fe4da9.otf";